var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcSync(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.70107 7.3125H8.01939C8.57168 7.3125 9.01939 7.76022 9.01939 8.3125C9.01939 8.86479 8.57168 9.3125 8.01939 9.3125H4C3.44772 9.3125 3 8.86479 3 8.3125V4.0625C3 3.51022 3.44772 3.0625 4 3.0625C4.55228 3.0625 5 3.51022 5 4.0625V6.26071C6.6078 3.70948 9.37288 2 12.5412 2C16.3696 2 19.6039 4.49211 20.9296 7.95498C21.127 8.47076 20.869 9.04895 20.3532 9.24641C19.8374 9.44386 19.2592 9.1858 19.0618 8.67002C18.0024 5.90275 15.4601 4 12.5412 4C10.1279 4 7.97584 5.298 6.70107 7.3125ZM4.64681 13.7536C5.16259 13.5561 5.74078 13.8142 5.93824 14.33C6.99762 17.0973 9.53988 19 12.4588 19C14.8721 19 17.0242 17.702 18.2989 15.6875H16.9806C16.4283 15.6875 15.9806 15.2398 15.9806 14.6875C15.9806 14.1352 16.4283 13.6875 16.9806 13.6875H21C21.5523 13.6875 22 14.1352 22 14.6875V18.9375C22 19.4898 21.5523 19.9375 21 19.9375C20.4477 19.9375 20 19.4898 20 18.9375V16.7393C18.3922 19.2905 15.6271 21 12.4588 21C8.63038 21 5.3961 18.5079 4.07043 15.045C3.87297 14.5292 4.13103 13.951 4.64681 13.7536Z",
    fill: "#101728"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSync);
export default __webpack_public_path__ + "static/media/ic-sync.07e13478b752790ae4f97b6998ced5bc.svg";
export { ForwardRef as ReactComponent };